import { getBaseUrl } from "./SecurityUtil"

export async function retrieveDelegateAccess(access_token, dpEid, dlgtEid) {
    const base_url = getBaseUrl()
    const requestOptions = getRequestOptions(access_token);

    const response = await fetch(`${base_url}/api/dpDelegation/queryOnEid/${dpEid}/${dlgtEid}`, requestOptions);
    const delegateResponse = await response.json();
    return delegateResponse.responseBody;
}

export async function retrieveDelegateData(accessToken, eid) {
    const base_url = getBaseUrl();
    const requestOptions = getRequestOptions(accessToken);

    const response = await fetch(`${base_url}/api/dpDelegation/queryOnEid/${eid}`, requestOptions)
    const delegateResponse = await response.json();
    return delegateResponse;
}

export async function retrieveFirmContactData(accessToken, dpEid) {
    const base_url = getBaseUrl();
    const requestOptions = getRequestOptions(accessToken);
    try {
        const response = await fetch(`${base_url}/api/dpDelegation/queryOnFirmContact/${dpEid}`, requestOptions);
        const fcResponse = await response.json();
        return fcResponse;
    } catch (error) {
        console.log('error occurred - retrieveFirmContactData:' + error)
    }
}

export async function retrieveFirmContactDataByTaxId(accessToken, taxId) {
    const base_url = getBaseUrl();
    let request = { 'taxId': taxId };
    const requestOptions = await postRequestOptions(accessToken, request)
        try {
        const response = await fetch(`${base_url}/api/dpDelegation/queryOnFirmContact`, requestOptions)
        const responseJson = await response.json();
		return responseJson;
    } catch (error) {
        console.log('error - retrieveFirmContactDataByTaxId:' + error)
    }
}

export async function retrieveDelegatingEntities(accessToken, dlgtEid) {
    const base_url = getBaseUrl();
    const requestOptions = getRequestOptions(accessToken);
    
    try {
        const response = await fetch(`${base_url}/api/dpDelegation/retrieveDelegatingEntities/${dlgtEid}`, requestOptions);
        const responseJson = await response.json();
        return responseJson;
    } catch (error) {
        console.log('error occurred - retrieveDelegatingEntities:' + error)
    }
}

export async function deleteDelegateData(accessToken, dpEid, dlgtEid, userEid) {
    const base_url = getBaseUrl();
    const requestOptions = getRequestOptions(accessToken);
    let response = null;       

    try {
        response = await fetch(`${base_url}/api/dpDelegation/deleteDelegate/${dpEid}/${dlgtEid}/${userEid}/${userEid}`, requestOptions);
        const { status } = response; 
        return status;
    } catch (error) {
        return false;
    }
}

export async function retrieveDelegatingEntityAccounts(accessToken, dpEid) {
    const base_url = getBaseUrl();
    const requestOptions = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${accessToken}`
        }
    }
    let jsonResp = "";
    try {
        const response = await fetch(`${base_url}/api/dpDelegation/retrieveDelegatingEntityAccounts/${dpEid}`, requestOptions)
        jsonResp = await response.json();
    } catch (error) {
    }
    return jsonResp;
}

export async function retrieveAccountRelationships(accessToken, contractId) {
    const base_url = getBaseUrl();
    const requestOptions = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${accessToken}`
        }
    }
    
    try {
        const resp = await fetch(`${base_url}/api/dpDelegation/retrieveAccountRelationships/${contractId}`, requestOptions)
		const respText = await resp.json()
		return respText
	} catch (error) {
        console.log('%cERROR: DelegateAPI - retrieveAssigned: ' + error, 'color: #C00000')
		return null
	}
    
}

function getRequestOptions(accessToken) {
    return {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${accessToken}`
        }
    }
}

export async function updateDelegates(access_token, request) {
    const base_url = getBaseUrl();

    const requestOptions = await buildPutRequestOptions(access_token, request)

    try {
        const updateUrl = `${base_url}/api/dpDelegation/updateDelegates`
        const response = await fetch(updateUrl, requestOptions)
        const { status, statusText } = response;
        return {
            "status"   : status, 
            "statusText" : statusText
        }
    
    } catch (error) {
        console.log('Error updating delegates in delegation service facade.')
        console.log(JSON.stringify(error))
    }

}
export async function addDelegates(access_token, request) {
    const base_url = getBaseUrl();

    const requestOptions = await postRequestOptions(access_token, request)

    try {
        const updateUrl = `${base_url}/api/dpDelegation/addDelegates`
        const response = await fetch(updateUrl, requestOptions)
        const { status, statusText } = response;
        let responseBody ="";
        if (status === 400) {
            responseBody = await response.json();
        }
        return {
            "status"   : status, 
            "statusText" : statusText+responseBody
        }
    
    } catch (error) {
        console.log('Error adding delegates in delegation service facade.')
        console.log(JSON.stringify(error))
    }
}

export async function pushToSNS(access_token, request) {
    const base_url = getBaseUrl();

    const requestOptions = await postRequestOptions(access_token, request)

    try {
        const updateUrl = `${base_url}/api/dpDelegation/postToSNS`
        const resp = await fetch(updateUrl, requestOptions)
		const respText = await resp.json()
		return respText
    
    } catch (error) {
        console.log('Error pushing to SNS.')
        console.log(JSON.stringify(error))
    }

}


async function buildPutRequestOptions(access_token, request) {
    const requestOptions = {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${access_token}`
      },
      body: JSON.stringify(request)
    }
    return requestOptions;
  }

async function postRequestOptions(access_token, request) {
    return {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			'Authorization': `Bearer ${access_token}`
		},
        body: JSON.stringify(request)
    }
}